/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Pagination from "react-js-pagination";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { saveAs } from 'file-saver';
import formatDateTimeToPST from "../PSTDateConvert";
import Loader from "../Loader";
import DatePicker from 'react-datepicker';
import PopupImage from '../CiaDashboard/PopupImage';

const CasImageStoreLog= () => {
    const location = useLocation();
    const abx = location.state;
    // console.log(abx);
    const [name, setName] = useState('');
    const [timeZone, seTimeZone] = useState('');
    const [cid, seCid] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [imageLog, setImageLog] = useState([]);
    const [error, setError] = useState(null);
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [searchValue, setSearchValue] = useState(abx != null ? abx.searchValue : "");
    const [selectedPlatform, setSelectedPlatform] = useState(abx != null ? abx.selectedPlatform : "");
    const [status, setStatus] = useState(abx != null ? abx.status : "0");
   
    const [popupOpen, setPopupOpen] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [displayDate, setDisplayDate] = useState("");
    const [searchDate, setSearchDate] = useState("");
    const [selectedCarrier, setSelectedCarrier] = useState(abx != null ? abx.selectedCarrier : "");

    const [isPopupTwoOpen, setIsPopupTwoOpen] = useState(false);
    const [selectedDataTwo, setSelectedDataTwo] = useState(null);
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const navigate = useNavigate();
 
    useEffect(() => {
        refreshToken();
        getUserAccess();
        getOrder(1,'', '', '','','','');
    }, []);
   
    useEffect(() => {
        if(role && token){
            checkAccess();
        }
    }, [role, token]);
    
 
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
            seCid(decoded.cid);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setAccess(response.data.results);
            // setIsLoading(false);
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    const openPopupTwo = async (e,path) => {
        e.preventDefault();
        const response = await axios.post(`${baseUrl}/get-dialed-number-file`, {path});
        const { presignedUrl } = response.data;
        setSelectedDataTwo(presignedUrl);
        setIsPopupTwoOpen(true);
    };

    const closePopupTwo = () => {
        setIsPopupTwoOpen(false);
        setSelectedDataTwo(null);
    };


    const handlePageChange  = (pageNumber) => {
        // console.log(`active page is ${pageNumber}`);
        setPage(pageNumber);
        console.log(searchValue);
        console.log(selectedPlatform);
        console.log(searchDate);
        getOrder(pageNumber,searchValue, selectedPlatform, selectedCarrier,searchDate,startTime,endTime);
    }
    const getOrder = async (page, searchValue, selectedPlatform, selectedCarrier,searchDate,startTime,endTime) => {
        console.log(page);
        console.log(searchValue);
        console.log(selectedPlatform);
        console.log(searchDate);
        if ((startTime && !searchDate) || (endTime && !searchDate)) {
            alert("Please select date.");
        } else if ((startTime && endTime) && startTime >= endTime) {
            alert("Start time must be earlier than end time.");
        } else {
            setPopupOpen(true);
            const response = await axiosJWT.get(`${baseUrl}/cia-image-store-log?page=${page}&limit=${500}&search=${searchValue}&platform=${selectedPlatform}&carrier=${selectedCarrier}&date=${searchDate}&start_time=${startTime}&end_time=${endTime}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setPopupOpen(false);
            console.log(response.data);
            

            const result = response.data.data;
            
            setImageLog(result);
            setTotalItem(response.data.totalItem);
        } 
    }
    const checkAccess = async () => {
        if(role > 2){
            navigate('/enrms-management');
        }
    }
    
    const handleCarrierChange = (e) => {
        setSelectedCarrier(e.target.value);
    };

    const handlePlatformChange = (e) => {
        setSelectedPlatform(e.target.value);
    };
    

    const clearFilter = () => {
        setStatus("");
        //setSelectedCompany(0);
        setSelectedPlatform("");
        setSelectedCarrier("");
        // setSelectedType("");
        // setSelectedRoute('');
        setSearchValue('');
        setSearchDate('');
        setDisplayDate('');
        setStartTime('');
        setEndTime('');
        //setSelectedEnrmsType("");
        setPage(1);
        //setSelectedItems([]);
        getOrder(1,0,'', '','','','');
        setIsFilter(false);
    }

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };
    const handleSearchSubmit = () => {
        setPage(1);
        //setSelectedItems([]);
        console.log(searchValue);
        console.log(selectedPlatform);
        console.log(searchDate);
        getOrder(1,searchValue, selectedPlatform, selectedCarrier,searchDate,startTime,endTime);
        // getUsers(1, selectedCompany, status, searchValue);
    };

    const handleSearchDate = (date) => { 
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
         console.log(formattedDate);
         setSearchDate(formattedDate);
        setDisplayDate(date);
    };

 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            
            setName(decoded.name);
            seTimeZone(decoded.timezone);
            setRole(decoded.role)
            setExpire(decoded.exp);
            seCid(decoded.cid);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const handleSubmit = () => {
        if (!startTime || !endTime) {
          alert("Please select both start and end times.");
        } else if (startTime >= endTime) {
          alert("Start time must be earlier than end time.");
        } else {
          alert(`Time range selected: ${startTime} to ${endTime}`);
        }
    };
 
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Image Upload Logs</h1>
                            </div>
                        </div>
                        <div className="col-6 inventory-btn">
                            <div className="addnew-button">
                                <Link to="/enrms-management"><span>&larr;</span> Back</Link>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8 order-filter">
                            <div className="boxinput">
                            
                                {/* <input className="search-leave satff-listing-page-search" type="text" name="search" placeholder="Search" value={searchValue} onChange={handleSearchChange} />                       */}
                                <select className="form-control" name="usertype" value={selectedPlatform} onChange={handlePlatformChange}>
                                 <option value="" >Platform</option>                                    
                                 <option value="ios">iOS</option>
                                 <option value="Android">Android</option>
                                </select>

                                <select className="form-control" name="usertype" value={selectedCarrier} onChange={handleCarrierChange}>
                                 <option value="" >Carrier</option>                                    
                                 <option value="T-Mobile">T-Mobile</option>
                                 <option value="ATT">ATT</option>
                                 <option value="Verizon">Verizon</option>
                                </select>

                                <DatePicker
                                    selected={displayDate}
                                    onChange={handleSearchDate}
                                    dateFormat="MM/dd/yyyy" // Set the desired date format
                                    placeholderText="Date"
                                    className="from-date"
                                />
                                <input
                                    type="time"
                                    value={startTime}
                                    placeholder="Start Time"
                                    onChange={(e) => setStartTime(e.target.value)}
                                />
                                <input
                                    type="time"
                                    value={endTime}
                                    placeholder="End Time"
                                    onChange={(e) => setEndTime(e.target.value)}
                                />
                                <button  className="search-btn" onClick={handleSearchSubmit}>Search</button>
                               { ( selectedCarrier || selectedPlatform || searchDate) && (<a className='search-btn clear-btn' onClick={clearFilter} >Clear</a>)}
                            </div>
                        </div>
                    </div>
                    
                    <div className="common-white-shadow-background setting-section">
                        <div className="row">
                        <div className=" setting-section haft-whitebox">
                                <table className="tablebox search-result-table inventory-table">
                                    <thead>
                                        <tr>  
                                            <th>ID</th>                                         
                                            <th>Platform</th>                                            
                                            <th>Image</th>
                                            <th>Telephone Number</th>
                                            <th>Device Phone Number</th>
                                            <th>App Version</th>
                                            <th>Call Verification Status</th>
                                            <th>Broadcast Status</th>
                                            <th>Cron Status</th>
                                            <th>Datetime</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {imageLog.map((item, index) => (
                                        <tr key={index}>
                                        <td>{item.id}</td>
                                        <td>{item.platform}</td>
                                        <td><a  href="#" onClick={(e) => openPopupTwo(e,item.path)}>
                                            {item.path ? item.path.substring(item.path.lastIndexOf('/') + 1) : ''}
                                        </a>
                                        </td>
                                        <td>{item.tn_number}</td>
                                        <td>{item.device_phone_number}</td>
                                        <td>{item.app_version}</td>
                                        <td> 
                                        {item.call_verification_status === 1 
                                        ? 'Verified' 
                                        : item.call_verification_status === 0 
                                        ? 'Unverified' 
                                        : item.call_verification_status === null 
                                        ? '-' 
                                        : '-'}
                                        </td>
                                        <td>
                                        {item.broadcast_status === 1 
                                        ? 'OFF' 
                                        : item.broadcast_status === 0 
                                        ? 'ON' 
                                        : item.broadcast_status === null 
                                        ? '-' 
                                        : '-'}
                                        </td>
                                        <td>
                                        {item.cron_status === 1 
                                        ? 'Not Executed' 
                                        : item.cron_status === 0 
                                        ? 'Executed' 
                                        : item.broadcast_status === null 
                                        ? '-' 
                                        : '-'}
                                        </td>
                                        <td>{item.created_at}</td>
                                        </tr>))}
                                         </tbody>
                                </table>
                                     {totalItem > 500 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={500}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                                {isPopupTwoOpen && <PopupImage data={selectedDataTwo} onClose={closePopupTwo} />}
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}
 
export default CasImageStoreLog